// extracted by mini-css-extract-plugin
export default {"dashboard-container":"EntriesGrid_dashboard-container__AgN8h","dashboard":"EntriesGrid_dashboard__31xn7","table":"EntriesGrid_table__cP5wq","mobile":"EntriesGrid_mobile__iAHDe"};